export const APP_CONFIG = {
  BASE_API: process.env.REACT_APP_BASE_API_URL,
  BASE_ROOT: process.env.REACT_APP_BASE_ROOT_URL,
};
